import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose, withState } from "recompose";
import { Responsive } from "semantic-ui-react";
import styled from "styled-components";
import Header from "./../header";
import Footer from "./../footer";
import Routes from "./../routes";
import Sidebar from "./../sidebar";
import ScrollUpButton from "./../scroll-up-button";

const Layout = ({ isAuthenticated, mainContainerRef, setMainContainerRef }) => (
  <Fragment>
    <LayoutSection>
      <Header />
      <Content isAuthenticated={isAuthenticated}>
        {isAuthenticated && <Sidebar />}
        <Main innerRef={setMainContainerRef}>
          <Routes />
        </Main>
      </Content>
      <Footer />
    </LayoutSection>
    <ScrollUpButton elementRef={mainContainerRef} />
  </Fragment>
);

Layout.propTypes = {
  mainContainerRef: PropTypes.instanceOf(Element),
  setMainContainerRef: PropTypes.func.isRequired
};

const LayoutSection = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
`;

const Content = styled.div`
  display: contents;
  flex-grow: 1;

  @media screen and (min-width: ${Responsive.onlyComputer.minWidth}px) {
    & > main {
      margin-left: ${({ isAuthenticated }) =>
        isAuthenticated && "calc(300px + 1rem)"};
      padding-right: ${({ isAuthenticated }) => isAuthenticated && "1rem"};
    }
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  scroll-behavior: smooth;

  & > * {
    margin: 1rem 0;
  }
`;

const mapStateToProps = ({ authentication }) => ({
  isAuthenticated: authentication.accessToken !== null
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps),
  withState("mainContainerRef", "setMainContainerRef")
);

export { Layout, enhance };
export default enhance(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/Layout.js